import { useEffect, useState } from "react";
import GCBatch from "../../../Component/Common/ReuseableComponent/GCBatch";
import {  GetUnitArr, sTrnTyp } from "../StockTransferRequestAction";
import {   StockTransferRequestRo } from "../../../Redux/roStore";
import { confirmAlert } from "react-confirm-alert";
import { inv10_deleteInv10CRow_GETROW,   inv10_Inv10CgetRow_GETROW,   inv10_updateInv10CRow_GETROW } from "../../../Server/ApiV2";
import { fAlertToast, fcovertToNumber } from "../../../Utility/Utilitys";
import moment from "moment";

 

const BatchSelectionModal = ({ 
  SerialDetalModal,
  sBatchObj,
  setBatchObj,
  closeModal,
  vRdxWmsHead,
  batchSelectionModal,
  batchFlag
}) => {
  const [GridDataColumnsBatch, setGridDataColumnsBatch] = useState([
    { field: "id", headerName: "id", hide: true },
    { field: "C_VocTyp", headerName: "VocTyp", hide: true },
    { field: "C_VocNo", headerName: "VocNo", hide: true },
    { field: "C_RowId", headerName: "SrNo" , },
    { field: "C_SrNo", headerName: "SrNoHead", hide: true },
    { field: "C_ItmCd", headerName: "Item Code", width: 90, hide: true },
    { field: "ItemName", headerName: "Item Name", width: 250, hide: true },
    { field: "C_BatchNo", headerName: "Batch No" },
    { field: "C_BatchDt", headerName: "MF Date" },
    { field: "C_ExpDt", headerName: "Exp Date" },
    { field: "C_Qty", headerName: "Qty" },   
    { field: "C_BaseQty", headerName: "BaseQty" },
    { field: "UnitName", headerName: "Unit" },
    { field: "C_Unit", headerName: "Unit", hide: true },
    { field: "C_Narr", headerName: "C_Narr", hide: true },
    { field: "C_PTyp1", headerName: "C_PTyp1", hide: true },
    { field: "C_PTyp2", headerName: "C_PTyp2", hide: true },
    { field: "C_PTyp3", headerName: "C_PTyp3", hide: true },
    { field: "C_PTyp4", headerName: "C_PTyp4", hide: true },
    { field: "C_PTyp5", headerName: "C_PTyp5", hide: true },
    { field: "C_PTyp1", headerName: "C_PTyp1", hide: true },
    { field: "C_PTyp6", headerName: "C_PTyp6", hide: true },
  ]);
  const [GridDataColumnSrno, setGridDataColumnSrno] = useState([
    { field: "id", headerName: "id", hide: true },
    { field: "C_VocTyp", headerName: "VocTyp", hide: true },
    { field: "C_VocNo", headerName: "VocNo", hide: true },
    { field: "C_RowId", headerName: "SrNo" , },
    { field: "C_SrNo", headerName: "SrNoHead", hide: true },
    { field: "C_ItmCd", headerName: "Item Code", width: 90, hide: true },
    { field: "ItemName", headerName: "Item Name", width: 250, hide: true },
    { field: "C_BatchNo", headerName: "Serial No" },
    { field: "C_BatchDt", headerName: "MF Date" },
    { field: "C_ExpDt", headerName: "Exp Date" },
    { field: "C_Qty", headerName: "Qty" },   
    { field: "C_BaseQty", headerName: "BaseQty" },
    { field: "UnitName", headerName: "Unit" },
    { field: "C_Unit", headerName: "Unit", hide: true },
    { field: "C_Narr", headerName: "C_Narr", hide: true },
    { field: "C_PTyp1", headerName: "C_PTyp1", hide: true },
    { field: "C_PTyp2", headerName: "C_PTyp2", hide: true },
    { field: "C_PTyp3", headerName: "C_PTyp3", hide: true },
    { field: "C_PTyp4", headerName: "C_PTyp4", hide: true },
    { field: "C_PTyp5", headerName: "C_PTyp5", hide: true },
    { field: "C_PTyp1", headerName: "C_PTyp1", hide: true },
    { field: "C_PTyp6", headerName: "C_PTyp6", hide: true },
  ]);
  const BatchDetail_ErrorMsg_Init = {
    BatchDetail_SrNo: "",
    BatchDetail_BatchNo: "",
    BatchDetail_MFDate: "",
    BatchDetail_ExpDate: "",
    BatchDetail_Qty: "",
    BatchDetail_Unit: "",
    BatchDetail_PackQty: "",
    BatchDetail_BaseQty: "",
  }; 
  const [sBatch_Total_Qty, setBatch_Total_Qty] = useState(0);
  const [sBatchDetailErrorMsg, setBatchDetailErrorMsg] = useState(
    BatchDetail_ErrorMsg_Init
  );
  const [batchnoFieldEnable, setbatchnoFieldEnable] = useState(false)
  
  // const [sBatchObj, setBatchObj] = useState({
  //   SrNo: 0,
  //   ItemCode: "",
  //   ItemName: "",
  //   Qty: 0,
  //   Unit: "",
  //   BaseQty: 0,
  // });
  const [sBatchUnit, setBatchUnit] = useState([]);
  const [sBatchCurrentEditQty, setBatch_Edit_BaseQty] = useState(0);
  const [sBatch_Load_GridData, setBatch_Load_GridData] = useState([]);
  const [sBatchDetailObj, setBatchDetailObj] = useState({
    BatchDetail_SrNo: 0, //rowId
    BatchDetail_BatchNo: SerialDetalModal?.Batch == "Y" ?0:"",
    BatchDetail_MFDate: new Date(),
    BatchDetail_ExpDate: new Date(),
    BatchDetail_Qty: 1,
    BatchDetail_Unit: "",
    BatchDetail_PackQty: 0,
    BatchDetail_BaseQty: 0,
    BatchDetail_BalanceQty: 0,
  });
 
  const fOpenBatchModal = (xSrno, xBaseQty, xPackQty) => {
    setBatchDetailErrorMsg(BatchDetail_ErrorMsg_Init);
    
    fBatch_Load_Grid(xSrno, xBaseQty, xPackQty);  
    setTimeout(() => { 
      document.getElementsByName("BatchDetail_BatchNo")[0]?.focus();
    }, 100);
  };
  
  const fBatch_CloseModal = (e) => {
    setBatchDetailErrorMsg(BatchDetail_ErrorMsg_Init);
    
   
    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_SrNo: 0,
      BatchDetail_BatchNo:  SerialDetalModal?.Batch == "Y" ?0:"",
      BatchDetail_MFDate: new Date(),
      BatchDetail_ExpDate: new Date(),
      BatchDetail_Qty: 1,
      BatchDetail_Unit: "",
      BatchDetail_PackQty: "",
    }));
    setBatchObj({
      SrNo: 0,
      ItemCode: "",
      ItemName: "",
      Qty: 0,
      Unit: "",
      BaseQty: 0,
    });
    setBatchUnit([]);
    setBatch_Load_GridData([]);
    setBatch_Total_Qty(0);
    setBatch_Edit_BaseQty(0); 
    closeModal()
  };
  
  const fBatch_New = () => {
    setBatchDetailErrorMsg(BatchDetail_ErrorMsg_Init);
  
    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_SrNo: 0,
      BatchDetail_BatchNo: SerialDetalModal?.Batch == "Y" ?0:"",
      BatchDetail_MFDate: new Date(),
      BatchDetail_ExpDate: new Date(),
      BatchDetail_Qty: 1,
      BatchDetail_Unit: sBatchUnit[0]?.Unit || "",
      BatchDetail_PackQty: sBatchUnit[0]?.PackQty || "",
    }));
    fBatch_BaseQty_Calculation(1, sBatchUnit[0].PackQty);
   
    if(sTrnTyp == "INV10" && batchFlag && SerialDetalModal?.Batch == "Y"){
      setbatchnoFieldEnable(true)
    }
    fBatch_Load_Grid(sBatchObj.SrNo, sBatchObj.BaseQty, sBatchUnit[0].PackQty);
    setBatch_Edit_BaseQty(0);
    setTimeout(() => { 
      document.getElementsByName("BatchDetail_BatchNo")[0]?.focus();
    }, 100);
   
  };

  const fBatch_Delete = async () => {
    confirmAlert({
      title: "Delete",
      message: "Are you sure you want to delete?",
      buttons: [
        {
          className: "alertBtn",
          label: "Yes",
          onClick: () => {
            fBatch_Delete2();
          },
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };
  const GetDeleteDetailBatch = async (xSrNo, xRowId, dispatch) => {
    const { HeadObject } = StockTransferRequestRo();
    let vDeleteDetailBatchObj = {
      v_C_VocTyp: HeadObject.A_VocTyp,
      v_C_VocNo: HeadObject.A_VocNo,
      v_C_SrNo: xSrNo,
      v_C_RowID: xRowId,
    };
    const resp = await inv10_deleteInv10CRow_GETROW(vDeleteDetailBatchObj);
  
    if (resp?.status === 200) {
      console.log(resp);
      fAlertToast("SUCCESS", "Successfully Deleted");
      return true;
    } else {
      fAlertToast("FAILED", "Batch not Deleted");
      return false;
    }
  };
  const fBatch_Delete2 = async () => {
    let iBatchDelete = await GetDeleteDetailBatch(
      sBatchObj.SrNo,
      sBatchDetailObj.BatchDetail_SrNo, 
    );
    if (!!iBatchDelete) {
      fBatch_New();
    }
  };
  const fValidationBatch_Client = (sBatchDetailObj, setBatchDetailErrorMsg,xbatchField=true) => {
    let iResp = true;
    // BatchDetail_SrNo: number;
    // BatchDetail_BatchNo: number;
    // BatchDetail_MFDate: Date;
    // BatchDetail_ExpDate: Date;
    // BatchDetail_Qty: number;
    // BatchDetail_Unit: string;
    // BatchDetail_PackQty: number;
    // BatchDetail_BaseQty: number;
  
    if (sBatchDetailObj.BatchDetail_SrNo === "") {
      setBatchDetailErrorMsg((obj) => ({
        ...obj,
        BatchDetail_SrNo: "Sr.No should not be zero",
      }));
      iResp = false;
    }
    if (sBatchDetailObj.BatchDetail_BatchNo === "") {
      setBatchDetailErrorMsg((obj) => ({
        ...obj,
        BatchDetail_BatchNo: xbatchField?"Batch.No should not be zero":"Serial.No should not be zero",
      }));
      iResp = false;
    }
    
    if ((sBatchDetailObj.BatchDetail_BatchNo === ""||  sBatchDetailObj.BatchDetail_BatchNo === 0) && SerialDetalModal?.Serial == "Y") {
      setBatchDetailErrorMsg((obj) => ({
        ...obj,
        BatchDetail_BatchNo: sBatchDetailObj.BatchDetail_BatchNo === ""?"Serial.No should not be empty":"Serial.No should not be zero",
      }));
      iResp = false;
    }
    
    if (sBatchDetailObj.BatchDetail_MFDate === "") {
      setBatchDetailErrorMsg((obj) => ({
        ...obj,
        BatchDetail_MFDate: "MFDate should not be zero",
      }));
      iResp = false;
    }
    if (sBatchDetailObj.BatchDetail_ExpDate === "") {
      setBatchDetailErrorMsg((obj) => ({
        ...obj,
        BatchDetail_ExpDate: "ExpDate should not be zero",
      }));
      iResp = false;
    }
    if (
      sBatchDetailObj.BatchDetail_Qty === "" ||
      sBatchDetailObj.BatchDetail_Qty <= 0
    ) {
      setBatchDetailErrorMsg((obj) => ({
        ...obj,
        BatchDetail_Qty: "Qty should not be zero",
      }));
      iResp = false;
    }
    if (sBatchDetailObj.BatchDetail_Unit === "") {
      setBatchDetailErrorMsg((obj) => ({
        ...obj,
        BatchDetail_Unit: "Unit should not be zero",
      }));
      iResp = false;
    }
    if (sBatchDetailObj.BatchDetail_PackQty === "") {
      setBatchDetailErrorMsg((obj) => ({
        ...obj,
        BatchDetail_PackQty: "PackQty should not be zero",
      }));
      iResp = false;
    }
    if (sBatchDetailObj.BatchDetail_BaseQty === "") {
      setBatchDetailErrorMsg((obj) => ({
        ...obj,
        BatchDetail_BaseQty: "BaseQty should not be zero",
      }));
      iResp = false;
    }
    return iResp;
  };
  const GetSaveDetailBatch = async (sBatchObj, sBatchDetailObj,  ) => {
    const { HeadObject } =  StockTransferRequestRo();
    // BatchDetail_SrNo: number;
    //   BatchDetail_BatchNo: number;
    //   BatchDetail_MFDate: Date;
    //   BatchDetail_ExpDate: Date;
    //   BatchDetail_Qty: number;
    //   : string;
    //   BatchDetail_PackQty: number;
    //   BatchDetail_BaseQty: number;
    let vSaveDetailBatchObj = {
      v_C_VocTyp: HeadObject.A_VocTyp,
      v_C_VocNo: HeadObject.A_VocNo,
      v_C_SrNo: sBatchObj.SrNo,
      v_C_ItmCd: sBatchObj.ItemCode,
      v_C_Qty: sBatchDetailObj.BatchDetail_Qty,
      v_C_Unit: sBatchDetailObj.BatchDetail_Unit,
      v_C_BaseQty: sBatchDetailObj.BatchDetail_BaseQty,
      v_C_Narr: "",
      v_C_BatchNo: sBatchDetailObj.BatchDetail_BatchNo,
      v_C_BatchDt: moment(sBatchDetailObj.BatchDetail_MFDate).format(
        "MM/DD/YYYY"
      ),
      v_C_ExpDt: moment(sBatchDetailObj.BatchDetail_ExpDate).format("MM/DD/YYYY"),
      v_C_PTyp1: "",
      v_C_PTyp2: "",
      v_C_PTyp3: 0,
      v_C_PTyp4: 0,
      v_C_PTyp5: 0,
      v_C_PTyp6: 0,
      v_C_RowID: sBatchDetailObj.BatchDetail_SrNo,
    };
    const resp = await inv10_updateInv10CRow_GETROW(vSaveDetailBatchObj);
    if (resp?.status === 200) {
      fAlertToast("SUCCESS", "Successfully Saved");
      return true;
    } else {
      fAlertToast("FAILED", "Batch not saved");
      return false;
    }
  };
  const fBatch_Save = async () => {
    setBatchDetailErrorMsg(BatchDetail_ErrorMsg_Init);
    let iValidationBatch = fValidationBatch_Client(
      sBatchDetailObj,
      setBatchDetailErrorMsg,
      SerialDetalModal?.Batch == "Y"
    );
    if (!iValidationBatch) return;

    if (
      Number(sBatchDetailObj.BatchDetail_BalanceQty) -
        Number(sBatchDetailObj.BatchDetail_Qty) <
      0
    ) {
      fAlertToast(
        "FAILED",
        "You are trying to save excess batch qty then purchase qty (Avl qty =" +
          sBatchDetailObj.BatchDetail_BalanceQty +
          ")"
      );
    } else {
      let iBatchSave = await GetSaveDetailBatch(
        sBatchObj,
        sBatchDetailObj,
         
      );
      if (!!iBatchSave) {
        fBatch_New();
      }
    }
  };
  
  const GetBatchDetail = async (xSrNo,  ) => {
    const { HeadObject } = StockTransferRequestRo();
    let vBatchDetailObj = {
      v_C_VocTyp: HeadObject?.A_VocTyp,
      v_C_VocNo: HeadObject?.A_VocNo,
      v_C_SrNo: xSrNo,
    };
    const resp = await inv10_Inv10CgetRow_GETROW(vBatchDetailObj);
    if (resp?.status === 200) {
      console.log(resp);
      let respData =
        resp?.data?.ResultSet?.length == 0
          ? []
          : resp?.data?.ResultSet.map((obj, i) => ({
              ...obj,
              id: i + 1,
            })); 
      return respData;
    } else {
      return [];
    }
  };
  
  const fBatch_Load_Grid = async (xSrNo, xBaseQty, xPackQty) => {
    let iBatchLoadGrid = await GetBatchDetail(xSrNo);
    if (iBatchLoadGrid.length > 0) { 
      let GridID = iBatchLoadGrid?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setBatch_Load_GridData(GridID); 
      console.log("asdfgh----",batchFlag,SerialDetalModal?.Batch,sTrnTyp);
       
      if(sTrnTyp == "INV10" && batchFlag && SerialDetalModal?.Batch == "Y" ){
         
        setBatchDetailObj((obj) => ({
          ...obj, 
          BatchDetail_BatchNo: SerialDetalModal.Batch == "Y" ?0: "", 
        }));
         
      }
      
      const { iTotalQty } = iBatchLoadGrid.reduce(
        (iValue, item) => {
          iValue.iTotalQty += item.C_BaseQty;
          return iValue;
        },
        { iTotalQty: 0 }
      );
      setBatch_Total_Qty(iTotalQty);
      fBatch_BalanceQty_Calculation(xBaseQty, iTotalQty, xPackQty, 0);
    } else {
      setBatch_Load_GridData([]);
      setBatch_Total_Qty(0);
      fBatch_BalanceQty_Calculation(xBaseQty, 0, xPackQty, 0);
    }
  };

  const fBatch_RowClick_Load_Grid = (item) => {
    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_SrNo: item.row.C_RowId, //rowId
      BatchDetail_BatchNo: item.row.C_BatchNo,
      BatchDetail_MFDate: moment(item.row.C_BatchDt, "DD/MM/YYYY")._d,
      BatchDetail_ExpDate: moment(item.row.C_ExpDt, "DD/MM/YYYY")._d,
      BatchDetail_Qty: item.row.C_Qty,
      BatchDetail_Unit: item.row.C_Unit,
      BatchDetail_BaseQty: item.row.C_BaseQty,
    }));
    setBatch_Edit_BaseQty(Number(item.row.C_BaseQty));
    let vItemUnitSet = sBatchUnit.find((obj) => {
      return obj.Unit === item.row.C_Unit;
    });
    let currentPackQty = sBatchUnit[0].PackQty;
    if (!!vItemUnitSet) {
      setBatchDetailObj((obj) => ({
        ...obj,
        BatchDetail_Unit: vItemUnitSet.Unit,
        BatchDetail_PackQty: vItemUnitSet?.PackQty,
      }));
      currentPackQty = vItemUnitSet?.PackQty;
    }
    fBatch_BalanceQty_Calculation(
      sBatchObj.BaseQty,
      sBatch_Total_Qty,
      currentPackQty,
      item.row.C_BaseQty
    );
  };

  const fBatch_BalanceQty_Calculation = (
    xBaseQty = 0,
    xTotalQty = 0,
    xPackQty = 0,
    xExistingQty = 0
  ) => {
    let vBalanceQty =
      Number(xPackQty) === 0
        ? 0
        : (fcovertToNumber(xBaseQty) +
            fcovertToNumber(xExistingQty) -
            fcovertToNumber(xTotalQty)) /
          fcovertToNumber(xPackQty);

    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_BalanceQty: vBalanceQty,
    }));
    return vBalanceQty;
  };

  const fBatch_BaseQty_Calculation = (xQty, xPackQty) => {
    let vBaseQty = fcovertToNumber(xPackQty) * fcovertToNumber(xQty);
    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_BaseQty: vBaseQty,
    }));

    return vBaseQty;
  };

  const fBatch_MFDate = (e) => {
    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_MFDate: e.$d,
    }));
  };

  const fBatch_ExpDate = (e) => {
    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_ExpDate: e.$d,
    }));
  };

  const fBatch_BatchNo = (e) => {
    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_BatchNo: e.target.value,
    }));
  };
  const fBatch_Qty = (e) => {
    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_Qty: e.target.value,
    }));
    fBatch_BaseQty_Calculation(
      Number(e.target.value),
      sBatchDetailObj.BatchDetail_PackQty
    );
  };
  const fBatch_Focus_Qty = (e) => {
    if (e.target.value == 0) {
      setBatchDetailObj((obj) => ({
        ...obj,
        BatchDetail_Qty: "",
      }));
    }
  };

  const fBatch_Blur_Qty = (e) => {
    if (e.target.value === "") {
      setBatchDetailObj((obj) => ({
        ...obj,
        BatchDetail_Qty: 0,
      }));
    }
  };

  const fBatch_Unit = (e) => {
    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_Unit: e.target.value,
    }));
    let vItemUnitSet = sBatchUnit.find((obj) => {
      return obj.Unit === e.target.value;
    });
    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_PackQty: vItemUnitSet?.PackQty,
    }));
    fBatch_BaseQty_Calculation(
      sBatchDetailObj.BatchDetail_Qty,
      vItemUnitSet?.PackQty
    );
    fBatch_BalanceQty_Calculation(
      sBatchObj.BaseQty,
      sBatch_Total_Qty,
      vItemUnitSet?.PackQty,
      sBatchCurrentEditQty
    );
  };

  const onload=async()=>{ 
   
    let currentUnitArr = await GetUnitArr(
      sBatchObj?.ItemCode,
      setBatchUnit
    );
    let currentPackQty = 0;

    if (currentUnitArr.length > 0) {
      setBatchDetailObj((obj) => ({
        ...obj,
        BatchDetail_Unit: currentUnitArr[0]?.Unit,
        BatchDetail_PackQty: currentUnitArr[0]?.PackQty,
      }));
      currentPackQty = currentUnitArr[0]?.PackQty;
    }

    fBatch_BaseQty_Calculation(sBatchDetailObj.BatchDetail_Qty , currentPackQty);

    fOpenBatchModal(
      sBatchObj.SrNo,
      sBatchObj.BaseQty,
      currentPackQty
    ); //baseqty 0
  }
  useEffect(() => {
    if(batchSelectionModal){
      
      onload() 
    }
  },[batchSelectionModal])

  return ( 
     <GCBatch
     xOpen={batchSelectionModal } //lutfi
     xErrorMsg={sBatchDetailErrorMsg}
     GridDataBatchRows={sBatch_Load_GridData}
     GridDataBatchColumns={SerialDetalModal?.Batch == "Y"?GridDataColumnsBatch :GridDataColumnSrno}
     xOnRowClick={fBatch_RowClick_Load_Grid}
     xBatchUnit={sBatchUnit}
     xTitle={SerialDetalModal?.Batch == "Y"? "Batch setup" : "Serial-setup"}
     xHeadSrNo={sBatchObj?.SrNo}
     xHeadItemCode={sBatchObj?.ItemCode}
     xHeadItemName={sBatchObj?.ItemName}
     xHeadQty={sBatchObj?.Qty}
     xHeadUnit={sBatchObj?.Unit}
     xHeadBaseQty={sBatchObj?.BaseQty}
     xDetailSrNo={sBatchDetailObj?.BatchDetail_SrNo}
     xDetailBatchNo={sBatchDetailObj?.BatchDetail_BatchNo}
     xDetailMFDate={sBatchDetailObj?.BatchDetail_MFDate}
     xDetailExpDate={sBatchDetailObj?.BatchDetail_ExpDate}
     xDetailQty={sBatchDetailObj?.BatchDetail_Qty}
     xDetailUnit={sBatchDetailObj?.BatchDetail_Unit}
     xDetailBaseQty={sBatchDetailObj?.BatchDetail_BaseQty}
     xDetailBalanceQty={sBatchDetailObj?.BatchDetail_BalanceQty}
     xBatch_fSrNo={""}
     xBatch_fBatchNo={fBatch_BatchNo}
     xBatch_fMFDate={fBatch_MFDate}
     xBatch_fExpDate={fBatch_ExpDate}
     xBatch_fQty={fBatch_Qty}
     xfBatch_Focus_Qty={fBatch_Focus_Qty}
     xfBatch_Blur_Qty={fBatch_Blur_Qty}
     xBatch_fUnit={fBatch_Unit}
     xBatch_fBaseQty={""}
     xfBatch_Close={fBatch_CloseModal}
     xfBatch_New={fBatch_New}
     xfBatch_Delete={fBatch_Delete}
     xfBatch_Save={fBatch_Save}
     xBtnDisable={vRdxWmsHead?.A_DocStat != "ENTER"}
     xTotalQty={sBatch_Total_Qty}
     isBatchNoEditable={SerialDetalModal?.Batch == "Y"?(sTrnTyp == "INV10" && batchnoFieldEnable && SerialDetalModal?.Batch == "Y"):false}
     batch={SerialDetalModal?.Batch == "Y"}
   />
  )

}
  
export default BatchSelectionModal;
